import { render, staticRenderFns } from "./OwnersAssociationHeader.vue?vue&type=template&id=523a5f26&scoped=true&"
import script from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociationHeader.vue?vue&type=style&index=0&id=523a5f26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a5f26",
  null
  
)

export default component.exports